import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/aggregation_account_resource.rb
// Registered from the systemic missing-schema audit (the #9130/#8988 class:
// an API-emittable JSON:API type the FE manifest never registered).
// aggregationLoans -> aggregation-loan and aggregationInstitution ->
// aggregation-institution remain unregistered; LegacyMode resolves those
// belongsTo/hasMany targets lazily, so referencing them here is safe.
const AggregationAccountSchema = withDefaults({
  type: 'aggregation-account',
  fields: [
    { kind: 'attribute', name: 'status' },
    {
      kind: 'hasMany',
      name: 'aggregationLoans',
      type: 'aggregation-loan',
      options: { async: false, inverse: null },
    },
    {
      kind: 'belongsTo',
      name: 'aggregationInstitution',
      type: 'aggregation-institution',
      options: { async: false, inverse: null },
    },
  ],
});

export default AggregationAccountSchema;
